export default __webpack_public_path__ + "826644b6e2abb9ed091a932405b8d5f8.svg";